module.exports = __webpack_public_path__ + "static/media/Zenith.da09dee5.png";